module.exports = __webpack_public_path__ + "img/logo_home.b7f62c2f.svg";